module.exports = __webpack_public_path__ + "static/media/OGG-tablet-types-2b.72d14027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-tablet-types-2b.jpg
// module id = 617
// module chunks = 0